import { Box, styled } from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  justify-content: center;
  margin: 30px 0;
`;
